export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-problem-2.b87f1ff0.png";